export default "__VITE_ASSET__zs3IpER5__"